define("framework-bundle",["DOM","Geolocation","Locale","Insights","Model","Module","Overlay","Page","Publisher","Social","System","Templates","Time","View","XHR"]);
//# sourceMappingURL=framework-bundle.js.map;
